import { privateConfig } from "../../config";
import { handleResponse } from "../../utils/handleResponse";

const contentfulService = ({ publicConfig }) => {
	const { CTF_API_URL, CTF_ENV, CTF_SPACE } = publicConfig;

	const baseUrl = `${CTF_API_URL}/spaces/${CTF_SPACE}/environments/${CTF_ENV}`;

	const headers = {
		Authorization: `Bearer ${privateConfig.CTF_CMA_TOKEN}`,
	};

	const getEntryById = async id =>
		fetch(`${baseUrl}/entries/${id}`, { headers }).then(handleResponse);

	const updateZendeskRecordId = async (id, value) => {
		const entry = await getEntryById(id);

		return fetch(`${baseUrl}/entries/${id}`, {
			method: "PATCH",
			body: JSON.stringify([
				{
					op: "add",
					path: "/fields/zendeskRecordId",
					value,
				},
			]),
			headers: {
				...headers,
				"X-Contentful-Version": entry.sys.version,
				"Content-Type": "application/json-patch+json",
			},
		}).then(handleResponse);
	};

	const publishEntryById = async (id, entryVersion) =>
		fetch(`${baseUrl}/entries/${id}/published`, {
			method: "PUT",
			headers: {
				...headers,
				"X-Contentful-Version": entryVersion,
			},
		}).then(handleResponse);

	return { getEntryById, updateZendeskRecordId, publishEntryById };
};

export default contentfulService;
